import { render, staticRenderFns } from "./lrTenantCompany.vue?vue&type=template&id=4327eebe&"
import script from "./lrTenantCompany.vue?vue&type=script&lang=js&"
export * from "./lrTenantCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports